module.exports = __webpack_public_path__ + "img/27.e3e6cd95.png";